// These four business events can be owned by the site OR by GTM, never both.
const LABELS = {
  trial_cta_click: '6KG6CPjqpdsYEPrS5vop',
  trial_contact_success: '0eAVCN2DoZUdEPrS5vop',
  trial_registration_success: 'T02oCOCDoZUdEPrS5vop',
  whatsapp_click: 'PFg8CPf3_vQcEPrS5vop'
}

function createTrialConversions(window, document, getPreferences, conversion, useGtm) {
  const subscribers = []
  let gtmLoaded = false
  // GTM's consent template subscribes using callInWindow, before conversion tags run.
  window.smmartTrialConsent = {
    subscribe: function (callback) {
      subscribers.push(callback)
      callback(getPreferences())
    }
  }

  function emit(name) {
    if (!LABELS[name] || !getPreferences().advertising) return
    window.dataLayer.push({ event: name, conversion_owner: useGtm ? 'gtm' : 'site' })
    if (!useGtm) conversion(LABELS[name])
  }

  function apply(value) {
    subscribers.forEach(callback => callback(value))
    if (!value.advertising) {
      // Do not replay queued conversions if consent is withdrawn while GTM downloads.
      for (let index = window.dataLayer.length - 1; index >= 0; index -= 1) {
        if (LABELS[window.dataLayer[index].event]) window.dataLayer.splice(index, 1)
      }
    } else if (useGtm && !gtmLoaded) {
      gtmLoaded = true
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })
      const script = document.createElement('script')
      script.async = true
      script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-W5S5KL9D'
      document.head.appendChild(script)
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return
    const trigger = event.target.closest(
      '[data-bs-toggle="modal"][data-bs-target="#trialRegistrationModal"], ' +
      '[data-bs-toggle="modal"][data-bs-target="#coachingTrialRegistrationModal"], ' +
      '[data-bs-toggle="modal"][data-bs-target="#informationTrialRegistrationModal"]')
    const targetId = trigger && trigger.getAttribute('data-bs-target').slice(1)
    if (trigger && !trigger.disabled && document.getElementById(targetId) &&
        !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
        (typeof event.button === 'undefined' || event.button === 0)) emit('trial_cta_click')
    const link = event.target.closest('a[href]')
    if (link) {
      // Match WhatsApp's host, not an arbitrary URL containing "wa.me".
      const url = document.createElement('a')
      url.href = link.href
      if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') emit('whatsapp_click')
    }
  }, true)

  document.addEventListener('smmart:trial-success', function (event) {
    const modal = event.target.closest && event.target.closest('#trialRegistrationModal, #coachingTrialRegistrationModal, #informationTrialRegistrationModal')
    if (!modal) return
    if (event.detail.step === 'contact' && modal.id === 'trialRegistrationModal') emit('trial_contact_success')
    if (event.detail.step === 'registration') emit('trial_registration_success')
  })

  return { apply }
}

module.exports = { createTrialConversions }
